import { listStyles as styles } from "@hardware/Overrides/Widgets/Brand/BrandGallery";
import { colorStrings } from "@hardware/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.imageItem = {
    ...styles.imageItem,
    css: css`
        ${styles.imageItem?.css}
        display: flex;
        justify-content: center;
        align-items: center;

        & > [style*="background-image"] {
            pointer-events: all !important;
        }
    `,
};

styles.link = {
    ...styles.link,
    css: css`
        ${styles.link?.css}
        background-color: ${getColor(colorStrings.commonGlobalWhite)};
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 0;
        transition: 0.3s;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-origin: content-box;
        pointer-events: all !important;
    `,
};

styles.image = {
    ...styles.image,
    css: css`
        display: none;
    `,
};
